import React from 'react'
import { StyledCloseButton } from './style'

type Props = {
  onClick: () => void
}

const ModalCloseButton: React.FC<Props> = ({ onClick }) => {
  return (
    <StyledCloseButton onClick={onClick} aria-label="close">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.65416 8.65416C9.02638 8.28195 9.62987 8.28195 10.0021 8.65416L23.3458 21.9979C23.7181 22.3701 23.7181 22.9736 23.3458 23.3458C22.9736 23.7181 22.3701 23.7181 21.9979 23.3458L8.65416 10.0021C8.28195 9.62987 8.28195 9.02638 8.65416 8.65416Z"
          fill="#313131"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3458 8.65416C23.7181 9.02638 23.7181 9.62987 23.3458 10.0021L10.0021 23.3458C9.62987 23.7181 9.02638 23.7181 8.65416 23.3458C8.28195 22.9736 8.28195 22.3701 8.65416 21.9979L21.9979 8.65416C22.3701 8.28195 22.9736 8.28195 23.3458 8.65416Z"
          fill="#313131"
        />
      </svg>
    </StyledCloseButton>
  )
}

export default ModalCloseButton
